<template>
    <div class="mProduct-container" v-observe-visibility="startAnimate">
        <div class="mainTextContainer" :class="{animate: animate, onlySafari: isSafari}">
            <h1 class="mainText">HECHA CON<br>EL SABOR<br> ORIGINAL<br><span class="spanOnMainText">0.0% ALCOHOL</span></h1>
        </div>
        <!-- <div class="mainTextContainer" :class="{animate: animate, onlySafari: isSafari}">
            <h1 class="mainText">EMPEZAR DE O.O<br><span class="span2">SABE BIEN</span></h1>
        </div> -->
        <!-- <div class="mainTextContainer2" :class="{animate: animate, onlySafari: isSafari}"><h2 class="span3">TODO EL SABOR, CERO ALCOHOL</h2></div> -->
        <img class="mBanner-image" :src="banner" alt="Nueva Cerveza Tecate 0.0, excelente para acompañar tus comidas">
        <img class="mBanner-image-mobile" :src="banner_mobile" alt="Nueva Cerveza Tecate 0.0, excelente para acompañar tus comidas">
        <img class="mBanner-title" :src="b_title" :class="{animate: animate, onlySafari: isSafari}" alt="Nueva Cerveza Tecate 0.0, con todo el sabor refrescante, notas de malta y sutiles aromas frutales. Un amargo característico y una espuma solida que le imprime carácter para completar la experiencia de una cerveza completa">
        <!-- <img class="mBanner-subtitle" :src="sub_title" :class="{animate: animate, onlySafari: isSafari}" alt="Nueva Cerveza Tecate 0.0, excelente para acompañar tus comidas. Hecha con el sabor original 0.0% alcohol"> -->

        <!-- <div class="mBanner-text">
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <h1 class="mTitle-banner">Adquiere tu R0.0SCA taquera en estas sucursales:</h1>
                <h2 :class="{onlySafari: isSafari}" class="mSubtitle-banner">TACOS LOS TARASCOS EN GUADALAJARA:</h2>
                <p class="mP-banner" :class="{onlySafari: isSafari}">SUCURSAL COPERNICO EXPRESS | SUCURSAL CHAPULTEPEC | SUCURSAL GUADALUPE | SUCURSAL ITESO | 
                    SUCURSAL LA CIMA | SUCURSAL CLOUTHIER | <br> SUCURSAL PLAZA PUNTO GALICIA 
                    | SUCURSAL SAN AGUSTÍN | SUCURSAL SAN JORGE | SUCURSAL STA MARGARITA | SUCURSAL TERRANOVA 
                    | <br> SUCURSAL TLAQUEPAQUE EXPRESS | SUCURSAL COPERNICO
                </p>
                <p class="mP-banner-mobile">SUCURSAL COPERNICO EXPRESS | SUCURSAL CHAPULTEPEC | <br>
                SUCURSAL GUADALUPE | SUCURSAL ITESO | SUCURSAL LA CIMA | <br> 
                SUCURSAL CLOUTHIER | SUCURSAL PLAZA PUNTO GALICIA | <br> 
                SUCURSAL SAN AGUSTÍN | SUCURSAL SAN JORGE | SUCURSAL STA MARGARITA | <br> 
                SUCURSAL TERRANOVA | SUCURSAL TLAQUEPAQUE EXPRESS | <br> SUCURSAL COPERNICO
                </p>
                <h2 :class="{onlySafari: isSafari}" class="mSubtitle-banner-two">TACOS LOS TARASCOS EN MONTERREY:</h2>
                <p class="mP-banner" :class="{onlySafari: isSafari}">SUCURSAL LAZARO EXPRESS | SUCURSAL PLAZA ANTICA | SUCURSAL PLAZA 
                    LORETO | SUCURSAL PLAZA EL CORTIJO DEL RIO | <br> SUCURSAL PLAZA FIESTA SAN AGUSTÍN | 
                    SUCURSAL PLAZA SIKARA
                </p>
                <p class="mP-banner-mobile">SUCURSAL LAZARO EXPRESS | SUCURSAL PLAZA ANTICA | <br> 
                SUCURSAL PLAZA LORETO | SUCURSAL PLAZA EL CORTIJO DEL RIO | <br> SUCURSAL PLAZA FIESTA SAN AGUSTÍN | 
                    SUCURSAL PLAZA SIKARA
                </p>
                <h2 :class="{onlySafari: isSafari}" class="mSubtitle-banner-three">TACOS DON MANOLITO EN CDMX:</h2>
                <p class="mP-banner" :class="{onlySafari: isSafari}">SUCURSAL ÁGUILAS  | SUCURSAL AXOMIATLA | SUCURSAL COYOACÁN | 
                    SUCURSAL OLIVAR | SUCURSAL PARAGON | SUCURSAL PEDREGAL | <br> SUCURSAL POLANCO | 
                    SUCURSAL REVOLUCIÓN | SUCURSAL ROMA | SUCURSAL SAN JERÓNIMO | SUCURSAL SANTA 
                    TERESA | SUCURSAL TLALPAN | <br> SUCURSAL SANTA FE | SUCURSAL NAPOLES
                </p>
                <p class="mP-banner-mobile">SUCURSAL ÁGUILAS  | SUCURSAL AXOMIATLA | SUCURSAL COYOACÁN | <br>
                    SUCURSAL OLIVAR | SUCURSAL PARAGON | SUCURSAL PEDREGAL | <br> SUCURSAL POLANCO | 
                    SUCURSAL REVOLUCIÓN | SUCURSAL ROMA | <br> SUCURSAL SAN JERÓNIMO | SUCURSAL SANTA 
                    TERESA | SUCURSAL TLALPAN | <br> SUCURSAL SANTA FE | SUCURSAL NAPOLES
                </p>
            </div>
        </div> -->
    </div>
</template>

<script>
import banner from '@/assets/product/BACK.png';
import banner_mobile from "@/assets/product/BACK_MOBILE.png";
import b_title from "@/assets/product/BANNER_TITLE.png"
import sub_title from "@/assets/product/BANNER_SUBTITLE.png"
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
    name: "Product",
    data() {
        return {
            banner,
            banner_mobile,
            b_title,
            sub_title,
            animate: false,
            isSafari: false
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        },
    },
    components: {},
    mounted() {
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Product.scss";
</style>